module.exports = __webpack_public_path__ + "img/50-1.fad6ca1b.svg";